import { connect } from 'react-redux';
import { Dispatch, ThunkDispatch } from '@reduxjs/toolkit';
import { setDropOutSurveyState } from '../../reducers/easyOnboardingSurvey/easyOnboardingSlice';
import { useEffect } from 'react';
import { RootState } from '../../../../configuration/setup/store';

enum IncomingMessageType {
    DROPOUT_SURVEY_STATE = 'EVENT_SHOW_EASY_ONBOARDING_SURVEY',
}

interface MessageEvent {
    data?: {
        type?: string;
    };
}

type DropoutSurveyEvent = MessageEvent & {
    data?: {
        payload?: {
            showSurvey?: boolean;
            connectionType?: string;
        };
    };
};

interface MessageHandlerProps {
    setDropOutSurveyState: (show: boolean, connectionType?: string) => void;
}

const receiveDropOutSurveyEvent = (
    event: DropoutSurveyEvent,
    setDropOutSurveyState: (show: boolean, connectionType?: string) => void
) => {
    const show = event.data?.payload?.showSurvey;
    const payload = event.data?.payload;
    if (payload != undefined && show !== undefined) {
        setDropOutSurveyState(show, payload.connectionType);
    }
};

const MessageHandler = (props: MessageHandlerProps): null => {
    const { setDropOutSurveyState } = props;
    useEffect(() => {
        const listenerCallback = (event: MessageEvent): void => {
            switch (event?.data?.type) {
                case IncomingMessageType.DROPOUT_SURVEY_STATE:
                    receiveDropOutSurveyEvent(event as DropoutSurveyEvent, setDropOutSurveyState);
                    break;
            }
        };
        window.addEventListener('message', listenerCallback, false);
        return (): void => window.removeEventListener('message', listenerCallback, true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const mapDispatchToProps = (dispatch: ThunkDispatch<Dispatch, RootState, any>): MessageHandlerProps => ({
    setDropOutSurveyState: (show: boolean, connectionType?: string): void => {
        dispatch(setDropOutSurveyState({ show, connectionType }));
    },
});

export const MessageHandlerContainer = connect(undefined, mapDispatchToProps)(MessageHandler);
